import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { submitFormToServer } from '../api';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    if (!formData.message.trim()) newErrors.message = 'Please tell us about your project';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setStatus('submitting');
    try {
      await submitFormToServer({
        Name: formData.name,
        Phone: formData.phone,
        Email: formData.email,
        Message: formData.message
      });
      setStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: ''
      });
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };
  if (status === 'success') {
    return <div className="rounded-2xl bg-green-50 p-8 text-center animate-in fade-in zoom-in duration-300" data-id="element-39">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100" data-id="element-40">
          <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-41" />
        </div>
        <h3 className="mb-2 text-2xl font-bold text-gray-900" data-id="element-42">Message Sent!</h3>
        <p className="text-gray-600 mb-6" data-id="element-43">
          Thanks for reaching out, {formData.name || 'friend'}! We'll get back
          to you shortly to discuss your bathroom remodel.
        </p>
        <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-44">
          Send Another Message
        </Button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-45">
      <div className="grid gap-6 md:grid-cols-2" data-id="element-46">
        <Input label="Name" placeholder="Your full name" value={formData.name} onChange={e => setFormData({
        ...formData,
        name: e.target.value
      })} error={errors.name} data-id="element-47" />
        <Input label="Phone" type="tel" placeholder="(555) 123-4567" value={formData.phone} onChange={e => setFormData({
        ...formData,
        phone: e.target.value
      })} error={errors.phone} data-id="element-48" />
      </div>

      <Input label="Email" type="email" placeholder="you@example.com" value={formData.email} onChange={e => setFormData({
      ...formData,
      email: e.target.value
    })} error={errors.email} data-id="element-49" />

      <Textarea label="How can we help?" placeholder="Tell us about your bathroom project..." value={formData.message} onChange={e => setFormData({
      ...formData,
      message: e.target.value
    })} error={errors.message} data-id="element-50" />

      {status === 'error' && <div className="flex items-center gap-2 text-red-600 bg-red-50 p-3 rounded-lg" data-id="element-51">
          <AlertCircle className="h-5 w-5" data-id="element-52" />
          <p className="text-sm" data-id="element-53">Something went wrong. Please try again.</p>
        </div>}

      <Button type="submit" variant="primary" size="lg" className="w-full" isLoading={status === 'submitting'} data-id="element-54">
        Request Free Consultation
      </Button>

      <p className="text-center text-xs text-gray-500 mt-4" data-id="element-55">
        We respect your privacy. No spam, ever.
      </p>
    </form>;
}